(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable no-param-reassign */
import * as T from "./types"; // config = {apiUrl}

const getInitialState = () => ({
  config: null
});

const _default = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload
  } = action;

  switch (action.type) {
    case T.INIT_CONFIG:
      state.config = payload.config;
      return state;

    default:
      return state;
  }
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getInitialState, "getInitialState", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/App/state/reducer.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/App/state/reducer.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();